import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import { Actions as LEAVEADJUSTMENTACTIONS } from "../../store/actions/leaveAdjustmentActions";
import LeaveAdjustmentRow from "./LeaveAdjustmentRow";
import ImportLeaveAdjustment from "./import-leave/adjustments/ImportLeaveAdjustment";
import ImportLeaveAdjustmentModal from "./import-leave/adjustments/ImportLeaveAdjustmentModal";
import Select from "react-select";
import _ from "lodash";
import { DateInputFormat } from "../common/DateComponents";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, subYears, addYears, format } from "date-fns";
import AddLeaveAdjustment from "./AddLeaveAdjustment";
import LeaveAdjustmentModal from "./LeaveAdjustmentModal";
import cleanDeep from "clean-deep";
import LoadingContent from "../common/LoadingContent";
import {
	ChevronDoubleLeftIcon,
	ChevronLeftIcon,
	ChevronDoubleRightIcon,
	ChevronRightIcon,
	PrinterIcon,
} from "@heroicons/react/20/solid";
import CalculateBackdatedPHModal from "./CalculateBackdatedPHModal";
import Spinner from "@/common/Spinner";
import Tooltip from "@/common/tooltip/Tooltip";
// import CalculateBackdatedPHModal from "./CalculateBackdatedPHModal";

const LeaveAdjustments = ({
	leaveLoading,
	leave,
	departmentOptions,
	employeeOptions,
	typeOptions,
	leaveTypeOptions,
	jobTypeOptions,
	getLeaveAdjustmentsByOrg,
	getLeaveAdjustmentsByAgreement,
	leaveAdjustments,
	userPermissions,
	hasDepartments,
	reportDownloading,
	downloadReport,
}) => {
	const [employee, setEmployee] = useState();
	const [selectedDepartment, setSelectedDepartment] = useState();
	const [type, setType] = useState();
	const [leaveType, setLeaveType] = useState();
	const [startDate, setStartDate] = useState(() => {
		const today = new Date();
		const firstDayOfMonth = new Date(today.getFullYear(), 0, 1);
		return new Date(firstDayOfMonth.getTime() - firstDayOfMonth.getTimezoneOffset() * 60000);
	});
	const [endDate, setEndDate] = useState(() => {
		const today = new Date();
		const lastDayOfMonth = new Date(today.getFullYear(), 12, 0);
		return new Date(lastDayOfMonth.getTime() - lastDayOfMonth.getTimezoneOffset() * 60000);
	});

	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;
	const lastPage = Math.ceil(leaveAdjustments?.length / itemsPerPage);

	const Pagination = () => {
		if (leaveAdjustments.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={7}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	const getReport = () => {
		downloadReport(
			cleanDeep({
				from: startDate,
				to: endDate,
				leaveType: leaveType && leaveType.value,
				adjustmentType: type && type.value,
				employee: employee && employee.value,
				department: selectedDepartment && selectedDepartment.value,
			}),
		);
	};

	useEffect(() => {
		getLeaveAdjustmentsByOrg(
			cleanDeep({
				before: format(endDate, "yyyy-MM-dd"),
				after: format(startDate, "yyyy-MM-dd"),
				leaveType: leaveType && leaveType.value,
			}),
		);
	}, []);

	useEffect(() => {
		employee
			? getLeaveAdjustmentsByAgreement({
					agreementId: employee.value,
					options: cleanDeep({
						before: format(endDate, "yyyy-MM-dd"),
						after: format(startDate, "yyyy-MM-dd"),
						leaveType: leaveType && leaveType.value,
					}),
				})
			: getLeaveAdjustmentsByOrg(
					cleanDeep({
						before: format(endDate, "yyyy-MM-dd"),
						after: format(startDate, "yyyy-MM-dd"),
						leaveType: leaveType && leaveType.value,
					}),
				);
	}, [endDate, startDate, leaveType, employee]);

	let filteredLeaveAdjustments = leaveAdjustments;
	if (type && type.value)
		filteredLeaveAdjustments = filteredLeaveAdjustments.filter((entry) => entry.adjustmentType == type.value);
	if (selectedDepartment)
		filteredLeaveAdjustments = filteredLeaveAdjustments.filter((entry) =>
			employeeOptions
				.filter((e) => e.department == selectedDepartment.value)
				.map((e) => e.value)
				.includes(parseInt(entry.agreement)),
		);

	console.log("filtered", selectedDepartment);

	if (!employeeOptions || !typeOptions || !leaveTypeOptions || !jobTypeOptions || !leave || leaveLoading)
		return <LoadingContent />;

	return (
		<div className="content">
			<ImportLeaveAdjustmentModal />
			<LeaveAdjustmentModal />
			<div>
				<div className="row">
					<div
						style={{ verticalAlign: "middle" }}
						className="pull-left"
					>
						<h5>Leave Adjustments</h5>
					</div>
					{userPermissions != "Read" && (
						<>
							<AddLeaveAdjustment />
							<ImportLeaveAdjustment />
							<CalculateBackdatedPHModal />
						</>
					)}
				</div>
				<div className="form-group">
					<div className="clearfix" />
					<div>
						<div className="col-sm-3 col-xs-6">
							<label>From</label>
							<DatePicker
								selected={startDate}
								onChange={(date) => setStartDate(date)}
								minDate={subYears(new Date(), 100)}
								maxDate={addYears(new Date(), 100)}
								dateFormat="dd/MM/yyyy"
								wrapperClassName="full-width"
								customInput={<DateInputFormat />}
							/>
							{/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
							<div className="clearfix" />
						</div>
						<div className="col-sm-3 col-xs-6">
							<label htmlFor=" ">To</label>
							<DatePicker
								selected={endDate}
								onChange={(date) => setEndDate(date)}
								minDate={subYears(new Date(), 100)}
								maxDate={addYears(new Date(), 100)}
								dateFormat="dd/MM/yyyy"
								wrapperClassName="full-width"
								customInput={<DateInputFormat />}
							/>
							<div className="clearfix" />
						</div>
						<div>
							{leaveTypeOptions && (
								<div className="col-sm-3 col-xs-6">
									<label htmlFor="material-text">Leave Type</label>
									<Select
										id="leave-type"
										value={leaveType}
										options={leaveTypeOptions}
										onChange={setLeaveType}
										isClearable
									/>
									<div className="clearfix" />
								</div>
							)}
							{typeOptions && (
								<div className="col-sm-3 col-xs-6">
									<label htmlFor="material-text">Adjustment Type</label>
									<Select
										id="type"
										value={type}
										options={typeOptions}
										onChange={setType}
										isClearable
									/>
									<div className="clearfix" />
								</div>
							)}
							<div style={{ paddingTop: 80 }}>
								{employeeOptions && (
									<div className="col-sm-3 col-xs-6">
										<label htmlFor="material-text">Employee</label>
										<Select
											id="employee"
											value={employee}
											options={employeeOptions}
											onChange={setEmployee}
											isClearable
										/>
										<div className="clearfix" />
									</div>
								)}
								{hasDepartments && (
									<div className="col-sm-3 col-xs-6">
										<label htmlFor="material-text">Department</label>
										<Select
											id="department"
											value={selectedDepartment}
											options={departmentOptions}
											onChange={setSelectedDepartment}
											isClearable
										/>
										<div className="clearfix" />
									</div>
								)}
								<div className="col-sm-1 col-xs-1 mt-9 pull-right">
									<Tooltip
										content="Print Leave Adjustment Report"
										className="pull-right"
									>
										<button
											type="button"
											className="btn btn-default pull-right"
											disabled={reportDownloading}
											onClick={getReport}
										>
											{reportDownloading ? (
												<Spinner style={{ height: "1.5em", float: "left" }} />
											) : (
												<PrinterIcon style={{ height: "1.5em", float: "left" }} />
											)}
										</button>
									</Tooltip>
								</div>
							</div>
						</div>
						<div className="clearfix" />
					</div>
				</div>
				<div className="table-responsive">
					<table
						id="table-timesheets"
						className="js-table-sections table table-hover"
					>
						<Pagination />
						<thead>
							<tr>
								<th>Date</th>
								<th>Employee</th>
								<th>Type</th>
								<th>Leave type</th>
								<th>Hours</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{filteredLeaveAdjustments &&
								filteredLeaveAdjustments
									.slice(start, end)
									?.map((entry) => <LeaveAdjustmentRow adjustment={entry} />)}
						</tbody>
					</table>
				</div>
				<div className="clearfix" />
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { leaveLoading, leave, leaveTypes, types } = state.leave;

	const { enableDepartments, departments } = state?.company?.settings;

	//All the company's employee
	const employeeListWithSalary = state && state.employees && state.employees.employeeListWithSalary;

	const employeeOptions =
		employeeListWithSalary &&
		employeeListWithSalary.map((employee) => ({
			value: employee.id,
			label: `${employee.employeeName} ${employee.employeeSurname}`,
			jobType: employee.employmentTypeName,
			department: employee.department,
		}));

	const typeOptions = [
		{
			value: "Carryover",
			label: "Carryover",
		},
		{
			value: "TOIL",
			label: "TOIL",
		},
		{
			value: "Manual",
			label: "Manual",
		},
		{
			value: "Balance as at",
			label: "Balance as at",
		},
		{
			value: "Consumed",
			label: "Consumed",
		},
	];

	const leaveTypeOptions =
		leaveTypes &&
		leaveTypes.map((leaveType) => ({
			value: leaveType.id,
			label: leaveType.name,
		}));

	const leaveStatusOptions = [
		{
			value: "Approved",
			label: "Approved",
		},
		{
			value: "Pending",
			label: "Pending",
		},
		{
			value: "Cancelled",
			label: "Cancelled",
		},
		{
			value: "Denied",
			label: "Denied",
		},
		{
			value: "Deleted",
			label: "Deleted",
		},
		{
			value: "Pending Cancellation",
			label: "Pending Cancellation",
		},
	];

	const departmentOptions = departments?.map((department) => ({
		value: department.id,
		label: department.name,
	}));

	const sortedLeave = _.orderBy(leave, ["start", "employeeName", "employeeSurname"], ["desc", "asc", "asc"]);
	const userPermissions = state?.permissions?.my?.permissions?.leave;

	const jobTypeOptions = [
		{
			value: "Part-time",
			label: "Part-Time",
		},
		{
			value: "Full-time",
			label: "Full-Time",
		},
	];

	return {
		userPermissions,
		leaveAdjustments: state && state.leaveAdjustments.adjustments,
		leaveLoading,
		leave: sortedLeave,
		hasDepartments: enableDepartments === undefined ? !!departments?.length : enableDepartments,
		leaveTypes,
		types,
		employeeOptions,
		employeeListWithSalary,
		departmentOptions,
		typeOptions,
		leaveTypeOptions,
		leaveStatusOptions,
		jobTypeOptions,
		reportDownloading: state.leaveAdjustments.reportDownloading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: (status, leave) => dispatch(LEAVEACTIONS.setOpenModal(status, leave)),
	getLeave: (options) => dispatch(LEAVEACTIONS.leaveGet(options, false)),
	downloadDetailedReport: (options) => dispatch(LEAVEACTIONS.downloadDetailedReport(options)),
	getLeaveBalance: () => dispatch(LEAVEACTIONS.getLeaveBalance()),
	getLeaveBalanceReport: () => dispatch(LEAVEACTIONS.getLeaveBalanceReport()),
	saveLeave: (leave) => dispatch(LEAVEACTIONS.saveLeave(leave)),
	showCancelLeave: (leave, status) => dispatch(LEAVEACTIONS.showCancelLeave(leave, status)),
	getLeaveAdjustmentsByOrg: (options) => dispatch(LEAVEADJUSTMENTACTIONS.getLeaveAdjustmentsByOrg(options)),
	getLeaveAdjustmentsByAgreement: ({ agreementId, options }) =>
		dispatch(LEAVEADJUSTMENTACTIONS.getLeaveAdjustmentsByAgreement({ agreementId, options })),
	downloadReport: (data) => dispatch(LEAVEADJUSTMENTACTIONS.downloadReport(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveAdjustments);
